import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-238af7e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "select-cate flex-ter mt_20 pb_20",
  style: {"border-bottom":"1px solid #F8F8F8"}
}
const _hoisted_2 = { class: "title ft-w-6 mr_20" }
const _hoisted_3 = { class: "cate-input btn fx-1 rel" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "abs fa fa-angle-down no-event" }, null, -1))
const _hoisted_5 = { class: "rel cascader" }
const _hoisted_6 = ["onMouseenter"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "abs second el-popover el-popper is-light"
}
const _hoisted_9 = { class: "cascader" }

import { ref, computed, reactive, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { isJA, isKO } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['hasMap', 'checkMap'],
  emits: ['update'],
  async setup(__props, { emit }) {

let __temp: any, __restore: any

const props = __props



const options: any = ref([])
const filterWord = ref('')
const nameKey = ref(isJA() ? 'cateNameJp' : isKO() ? 'cateNameKr' : 'cateNameEn')
const first = computed(() => {
  if (filterWord.value) {
    return options.value.filter((v: any) =>
      v[nameKey.value].includes(filterWord.value)
    )
  } else {
    return options.value
  }
})
const second: any = ref(null)

const hasMap: any = reactive(props.hasMap)
const checkMap: any = reactive({ ...props.checkMap })
const mapName: any = reactive({})

const store = useStore()
const buss = store.state.bussiness
const res = (
  ([__temp,__restore] = _withAsyncContext(() => buss.promise.then(() =>
  JSON.parse(JSON.stringify(buss.category['0'].slice(1)))
))),
  __temp = await __temp,
  __restore(),
  __temp
)
res.forEach((v: any) => {
  v.value = v.productCategoryFrontendId
  // 一级类目设为计算值
  checkMap[v.value] = computed({
    get: () => v.children.every((v2: any) => checkMap[v2.value]),
    set: (val) => {
      v.children.forEach((v2: any) => {
        if (!hasMap[v2.value]) {
          checkMap[v2.value] = val
        }
      })
    }
  })
  const arr = v.children.map((v2: any) => {
    delete v2.children
    v2.value = v2.productCategoryFrontendId
    mapName[v2.value] = v2[nameKey.value]
    return hasMap[v2.value]
  })
  // 一级类目是否不可选
  hasMap[v.value] = arr.every((v: any) => v)
})
options.value = res

const selected = computed(() => {
  return Object.entries(checkMap).reduce(
    (obj: any, [k, v]) => {
      if (mapName[k] && v) {
        obj.list.push(k)
        obj.str += mapName[k] + '/'
      }
      return obj
    },
    { str: '', list: [] }
  )
})

watch(selected, (v) => {
  emit(
    'update',
    v.list.map((v: string) => Number(v))
  )
})

const popoption = {
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [0, 5]
      }
    }
  ]
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)('选择您要配置的类目')), 1),
    _createVNode(_component_el_popover, {
      trigger: "click",
      teleported: false,
      "hide-after": 0,
      "popper-options": popoption,
      width: 240,
      placement: "bottom-start"
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_unref(selected).str.slice(0, -1)), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            class: "mb_5",
            size: "small",
            modelValue: filterWord.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterWord).value = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["modelValue"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(first), (v) => {
            return (_openBlock(), _createElementBlock("div", {
              key: v.value,
              class: _normalizeClass(["flex-ter-bwn item", { active: second.value === v.children }]),
              onMouseenter: ($event: any) => (second.value = v.children)
            }, [
              _createVNode(_component_el_checkbox, {
                modelValue: _unref(checkMap)[v.value],
                "onUpdate:modelValue": ($event: any) => ((_unref(checkMap)[v.value]) = $event),
                disabled: _unref(hasMap)[v.value]
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(v[nameKey.value]), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
              _hoisted_7
            ], 42, _hoisted_6))
          }), 128)),
          (second.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(second.value, (v) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: v.value,
                      class: "flex-ter item"
                    }, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _unref(checkMap)[v.value],
                        "onUpdate:modelValue": ($event: any) => ((_unref(checkMap)[v.value]) = $event),
                        disabled: _unref(hasMap)[v.value]
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v[nameKey.value]), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})